<template>
  <div>
    <v-data-table
      v-model="table.selected"
      :headers="table.headers"
      :server-items-length="getTotalItems()"
      :items="processedAutomaticResponse"
      :items-per-page="automaticResponse && automaticResponse.meta ? parseInt(automaticResponse.meta.per_page) : 0"
      :page.sync="table.page"
      :options.sync="table.options"
      :sort-by.sync="table.sortBy"
      :sort-desc.sync="table.sortDesc"
      :loading="table.loading"
      item-key="id"
      class="elevation-1 mt-4"
      @click:row="rowClick"
      hide-default-footer
    >
      <template v-slot:top>
        <v-row class="px-4 mx-0 pt-0">
          <v-col cols="12" md="3" sm="12" class="pa-0 ma-0">
            <v-select
                class="mr-md-2 my-2"
                v-model="table.filters.account"
                :error="accountError"
                :items="accounts.data || []"
                :loading="loadingAccounts"
                item-text="account_name"
                item-value="name"
                menu-props="auto"
                label="Conta"
                hide-details
                single-line
                outlined
                color="primary"
                dense
                clearable
              />
          </v-col>
          <v-col cols="12" md="5" sm="12" class="pa-0 ma-0">
            <v-text-field class=" my-2" v-model="table.filters.search" append-icon="mdi-magnify" clearable
              label="Procurar" single-line hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>

        <v-row class="px-4 mx-0 pt-2">
          <v-btn v-if="canCreateAR" small color="primary" outlined @click="openCreate" class="mr-2">
            <v-icon left>mdi-plus</v-icon>
            Criar nova
          </v-btn>

          <AutomaticResponseXlsFileModal class="mr-2" :accountNameXls="table.filters.account"/>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-pagination class="mb-4" v-model="table.page"
          :length="automaticResponse && automaticResponse.meta ? Math.ceil(parseInt(automaticResponse.meta.total) / parseInt(automaticResponse.meta.per_page)) : 0"></v-pagination>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <automatic-response-detail-modal 
      v-model="openModalDetail"
      :title="action === 'CREATE' ? 'Criar resposta automática' : (canUpdateAR ? 'Editar resposta automática' : 'Resposta automática')" 
      :data-info="automaticResponseSelected"
      :action-type="action" 
      :on-close="closeDetail"
      :on-save="saved" 
      :on-delete="deleted"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import { handleResponseError } from '@/api/handleError'
import * as permissionsNames from '@/constants/permissions'
import hasPermission from '@/helpers/hasPermission'
import AutomaticResponseDetailModal from '@/views/AutomaticResponse/AutomaticResponseDetailModal'
import AutomaticResponseXlsFileModal from '@/views/AutomaticResponse/AutomaticResponseXlsFileModal'

export default {
  name: 'AutomaticResponse',
  computed: {
    ...mapState({
      automaticResponse: state => state.automaticResponse.all,
      accounts: state => state.accounts.all,
    }),
    processedAutomaticResponse() {
      if (this.automaticResponse && this.automaticResponse.data) {
        return this.automaticResponse.data.map(item => ({
          ...item,
          review_without_comment: item.review_without_comment ? 'Sim' : 'Não'
        }));
      } else {
        return [];
      }
    },
    _() {
      return _
    },
    canCreateAR() {
      return hasPermission(permissionsNames.CAN_STORE_AUTOMATIC_RESPONSE)
    },
    canUpdateAR() {
      return hasPermission(permissionsNames.CAN_UPDATE_AUTOMATIC_RESPONSE)
    },
  },
  components: {
    AutomaticResponseDetailModal,
    AutomaticResponseXlsFileModal
  },
  methods: {
    fetchAutomaticResponses: async function () {
      this.table.loading = true
      await this.$store.dispatch('automaticResponse/getAutomaticResponses', {
        account: this.table.filters.account,
        search: this.table.filters.search,
        page: this.page,
        limit: this.limit,
        order: this.sortDesc ? 'desc' : 'asc',
        sort: this.sortBy,
      }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as respostas automáticas.')
        this.showNotification(message, 'red darken-2')
        this.table.loading = false
      })
      this.table.loading = false
    },
    fetchAccounts: async function () {
      this.loadingAccounts = true
      this.accountError = false
      await this.$store.dispatch('accounts/getAccounts', { limit: 0 }).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar as contas.')
        this.showNotification(message, 'red darken-2')
        this.loadingAccounts = false
        this.accountError = true
      })
      this.loadingAccounts = false
      this.accountError = false
    },
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    getTotalItems: function () {
      return this.automaticResponse && this.automaticResponse.meta ? parseInt(this.automaticResponse.meta.total) : 0
    },
    openDetail: function () {
      this.openModalDetail = true
    },
    closeDetail: function () {
      this.openModalDetail = false
      this.automaticResponseSelected = {}
    },
    rowClick: function (keyword) {
      this.automaticResponseSelected = keyword
      this.action = 'EDIT'
      this.openDetail()
    },
    saved: function () {
      this.showNotification(`Resposta automática ${this.action === 'CREATE' ? 'criada' : 'atualizada'}!`, 'green')
      this.fetchAutomaticResponses()
      this.closeDetail()
    },
    deleted: function () {
      this.showNotification('Resposta automática excluída!', 'green')
      this.fetchAutomaticResponses()
      this.closeDetail()
    },
    openCreate: function () {
      this.action = 'CREATE'
      this.automaticResponseSelected = {}
      if(this.table.filters.account) {
        const { id: account_id, ...accountFound } = this.accounts?.data?.find(
          account => account.name === this.table.filters.account
        )
        this.automaticResponseSelected = {
          ...accountFound,
          account_id,
          labels: [],
          star_rating: '',
          name: '',
          review_without_comment: 'Não',
        }
      }
      this.openDetail()
    },
  },
  watch: {
    'table.options': function (options) {
      let sortBy = options.sortBy[0]
      const sortDesc = options.sortDesc[0]
      if ((sortBy || '').includes('formatted')) {
        const s = sortBy.split('_formatted')
        sortBy = s[0]
      }

      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.page = options.page
      this.limit = 20
      this.fetchAutomaticResponses()
    },
    'table.filters.search': function () {
      clearTimeout(this.timeoutSearch)
      this.timeoutSearch = setTimeout(this.fetchAutomaticResponses, 300)
    },
    'table.filters.account': function () {
      this.fetchAutomaticResponses()
    },
  },
  created() {
    this.fetchAutomaticResponses()
    this.fetchAccounts()
  },
  data: () => ({
    action: 'EDIT',
    openModalDetail: false,
    automaticResponseSelected: {},
    timeoutSearch: null,
    accountError: '',
    loadingAccounts: false,
    sortBy: '',
    sortDesc: '',
    limit: 20,
    page: 1,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    table: {
      loading: false,
      filters: {
        account: '',
        search: '',
        labels: [],
        star_rating:'',
        review_without_comment: false,
      },
      headers: [
        { text: 'Nome', value: 'name', align: 'start' },
        { text: 'Conta', value: 'account_name', sortable: true },
        { text: 'Labels', value: 'labels', sortable: true },
        { text: 'Star Rating', value: 'star_rating', sortable: true },
        { text: 'Responder sem comentario', value: 'review_without_comment', sortable: true },
      ],
      page: 1,
      limit:20,
      sortBy: null,
      sortDesc: false,
      options: {},
    },
  }),
}
</script>